import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { reformatData } from "../../../util/helperFunctions";
import moment from 'moment';
import { INTERVAL_MAP } from "../../../components/MetricChart/metricChartUtil";
import { fetchExpressions } from "../../../api/sensorApi";


const getTagSummary = async (id, start, end, interval) => {
    const spec = {
        sensor: id,
        start: moment(start).format("YYYY-MM-DD"),
        end: moment(end).format("YYYY-MM-DD"),
        interval: interval.charAt(0)
    };
    try {
        const res = await fetchExpressions("DewDataMeasurementExpression", spec);
        const summary_raw = reformatData([res])
        const timeseries_summary = []
        const dewData = summary_raw[0]['result'][id]['DewData'].data;
        for(let idx = 0; idx < dewData.length; idx++) {
            const item = dewData[idx];
            if(item > 0) {
                const timestamp = summary_raw[0]['result'][id]['DewData'].dates[idx];
                const startDate = moment(timestamp).format("YYYY-MM-DD");
                const [mult, momentInterval] = INTERVAL_MAP[interval];
                const endDate = moment(timestamp).add(mult, momentInterval).format("YYYY-MM-DD");

                timeseries_summary.push({
                    start: startDate,
                    end: endDate,
                    total_hours: item
                });
            }
        }
        timeseries_summary.sort((a, b) => b.total_hours - a.total_hours);
        return timeseries_summary
    } catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return [];
    }
};

function useGetDewSeriesSummary(item, analysisDates, interval) {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        async function fetchData() {
            if (item) {
                setIsLoading(true);
                try {
                    console.log(analysisDates)
                    // Fetch dew series
                    const tag_summary = await getTagSummary(item.id, analysisDates.start, analysisDates.end, interval);
                    console.log("Dew series summary fetched:", tag_summary);
                    setData(tag_summary);
                }
                catch (error) {
                    console.error("Error fetching dew series data:", error);
                    toast.error("Error fetching dew series data. Please try again later.");
                } finally {
                    setIsLoading(false);
                }

            }
        }
        fetchData();

    }, [item, analysisDates, interval]);

    return {
        data,
        isLoading
    };
}
export default useGetDewSeriesSummary;